import { getTenantForDevelopment, getTenantForProduction } from './getTenant';

export { getTenantForDevelopment, getTenantForProduction };
